import { Button } from "@chakra-ui/button";
import React from "react";
import ICalendarLink from "react-icalendar-link";
import { Session } from "types/session";
import { GetAttendeeList } from "utils/user";

interface Props {
  session: Session;
}


const CalendarLink: React.FC<Props> = ({ session }: Props) => {
  const { title, start_time, end_time, coach, participants } = session;
  return (
    <ICalendarLink
      event={{
        title,
        startTime: start_time.toString(),
        endTime: end_time.toString(),
        attendees: GetAttendeeList(coach, participants)
      }}
    >
      <Button size="xs" variant="blue">
        Add to Calendar
      </Button>
    </ICalendarLink>
  );
};

export default CalendarLink;
